import { createDefaultSave, defaultProfile, defaultSettings } from "../game/gameState";
import type { SaveData } from "../types";

const STORAGE_KEY = "unread-zero.save.v1";

function normalizeSave(value: unknown): SaveData {
  if (!value || typeof value !== "object") return createDefaultSave();
  const partial = value as Partial<SaveData>;
  return {
    version: 1,
    settings: { ...defaultSettings, ...(partial.settings ?? {}) },
    profile: {
      ...defaultProfile,
      ...(partial.profile ?? {}),
      endings: partial.profile?.endings ?? [],
      discoveredAnomalyIds: partial.profile?.discoveredAnomalyIds ?? []
    },
    currentRun: partial.currentRun
  };
}

export function loadSave(): SaveData {
  if (typeof window === "undefined") return createDefaultSave();
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    return raw ? normalizeSave(JSON.parse(raw)) : createDefaultSave();
  } catch (error) {
    console.warn("Failed to load save data.", error);
    return createDefaultSave();
  }
}

export function writeSave(save: SaveData): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(save));
  } catch (error) {
    console.warn("Failed to write save data.", error);
  }
}

export function clearSave(): SaveData {
  if (typeof window !== "undefined") window.localStorage.removeItem(STORAGE_KEY);
  return createDefaultSave();
}
